module.exports = __webpack_public_path__ + "img/35t.ecf05afc.jpg";